import cn from 'classnames';
import React, { forwardRef, type ReactNode } from 'react';
import { Text } from 'src/components/text/Text';

import styles from './SnippetContent.css';

interface Props {
  classNameContent?: string;
  classNameText?: string;
  classNameLink?: string;
  link?: ReactNode;
  message?: ReactNode;
}

export const SnippetContent = forwardRef<HTMLDivElement, Props>(
  ({ classNameContent, classNameLink, classNameText, link, message }, ref) => {
    return (
      <div className={cn(styles.SnippetContent, classNameContent)} ref={ref}>
        <div
          className={cn(styles.SnippetContent__Text, classNameText)}
          data-test="promo-widget-snippet-text-container"
        >
          <Text
            as="span"
            variant="body2Tight"
            data-test="promo-widget-snippet-text"
          >
            {message}
          </Text>{' '}
          {!!link && (
            <Text
              as="span"
              variant="body2TightBold"
              className={cn(styles.SnippetContent__Link, classNameLink)}
              data-test="widget-learn-more"
            >
              {link}
            </Text>
          )}
        </div>
      </div>
    );
  }
);

SnippetContent.displayName = 'SnippetContent';
